var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#efefef",
    width: "800px",
    height: "800px",
    viewBox: "-6.5 0 32 28",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#efefef",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "five"), /*#__PURE__*/React.createElement("path", {
    d: "M7.938 4.875l-1.125 6c0.625-0.188 1.313-0.281 2.031-0.281 4.281 0 7.75 3.5 7.75 7.781s-3.469 7.75-7.75 7.75c-3.656 0-6.406-2.5-7.25-5.938h2.281c0.781 2.219 2.531 3.813 5 3.813 3.094 0 5.594-2.5 5.594-5.594 0-3.063-2.5-5.625-5.594-5.625-0.813 0-1.656 0.188-2.531 0.438-0.938 0.25-1.594 0.438-2.438 0.844l2.188-11.438h9.906v2.25h-8.063z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFive);
export default __webpack_public_path__ + "static/media/five.311807ffe3efec7cfeccc24c61139ce3.svg";
export { ForwardRef as ReactComponent };